export { includes } from './includes/includes';
export { toArray } from './toArray/toArray';

export const arrayProto = Array.prototype;
